// assets/ppl-gallery-arrow-sync.js

(() => {
  if (window.__pplGalleryArrowSyncInit) {
    window.__pplGalleryArrowSyncInit();
    return;
  }
  function init() {
    document.querySelectorAll('media-gallery[id^="MediaGallery-"]').forEach((mediaGallery) => {
      if (mediaGallery._pplSynced) return;

      const sectionId   = mediaGallery.id.replace('MediaGallery-', '');
      const viewer      = mediaGallery.querySelector('[id^="GalleryViewer-"]');
      const thumbSlider = mediaGallery.querySelector('[id^="GalleryThumbnails-"]');
      if (!viewer || !thumbSlider) return;

      const prevBtn = viewer.querySelector('.ppl-galleryArrow--prev');
      const nextBtn = viewer.querySelector('.ppl-galleryArrow--next');
      if (!prevBtn || !nextBtn) return;
      mediaGallery._pplSynced = true;
      const slider = viewer.querySelector('[id^="Slider-Gallery-"]');

      function keepButtonsEnabled() {
        prevBtn.removeAttribute('disabled');
        nextBtn.removeAttribute('disabled');
      }

      function getVisibleItems() {
        return Array.from(thumbSlider.querySelectorAll('.thumbnail-list__item'))
          .filter(item =>
            !item.classList.contains('thumbnail-list_item--variant') ||
            item.id.endsWith('-0')
          );
      }

      function getActiveIndex() {
        const items = getVisibleItems();

        const byAria = items.findIndex(item =>
          item.querySelector('button.thumbnail[aria-current="true"]')
        );
        if (byAria !== -1) return byAria;

        const activeSlide = viewer.querySelector('.slider__slide.is-active[data-media-id]');
        if (activeSlide) {
          const mediaId = activeSlide.dataset.mediaId;
          const bySlide = items.findIndex(item => item.dataset.target === mediaId);
          if (bySlide !== -1) return bySlide;
        }

        return 0;
      }

      function navigateTo(index) {
        const items = getVisibleItems();
        if (!items.length) return;
        const target = ((index % items.length) + items.length) % items.length;
        const btn = items[target].querySelector('button.thumbnail');
        if (btn) btn.click();
        window.requestAnimationFrame(keepButtonsEnabled);
      }

      prevBtn.addEventListener('click', (e) => {
        e.stopImmediatePropagation();
        navigateTo(getActiveIndex() - 1);
      }, true);

      nextBtn.addEventListener('click', (e) => {
        e.stopImmediatePropagation();
        navigateTo(getActiveIndex() + 1);
      }, true);

      keepButtonsEnabled();
      viewer.addEventListener('slideChanged', keepButtonsEnabled);
      if (slider) {
        slider.addEventListener('scroll', () => {
          window.requestAnimationFrame(keepButtonsEnabled);
        });
      }
    });
  }

  window.__pplGalleryArrowSyncInit = init;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
